/**
 * Loads a script from the given URL and returns a promise that resolves when
 * the script is loaded.
 *
 * Only works client side.
 *
 * @param url The URL of the script to load.
 * @param id Optional id to apply to the script tag.
 */
export function loadScript(url, attributes) {
    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.setAttribute("src", url);
        script.setAttribute("type", "text/javascript");
        for (const [key, value] of Object.entries(attributes.dataset || {})) {
            script.dataset[key] = value;
        }
        if (attributes.id) {
            script.setAttribute("id", attributes.id);
        }
        if (attributes.async) {
            script.setAttribute("async", "true");
        }
        document.body.append(script);
        script.addEventListener("load", () => resolve());
        script.addEventListener("error", () => {
            script.remove();
            reject();
        });
    });
}
//# sourceMappingURL=load-script.js.map